const styles = {
  modalArea: {
    width: '400px',
  },
  gridStyle: {
    marginTop: '30px',
  },
};
export default styles;
